<template>
    <div>
        <div class="grid-content maintitle">
            <span>员工管理/编辑员工</span>
        </div>
        <div class="topContainer">
            <div class="grid-content content-margin topFix">
                <div class="buttonarea">
                    <el-link :underline="false">
                        <el-button size="medium" round @click="backTarget">
                            <i class="iconfont">&#xe600;</i>
                            {{ $t("message.返回") }}
                        </el-button>
                    </el-link>
                    <el-link :underline="false" v-show="!isEditMode && !isInit">
                        <el-button size="medium" round @click="isEditMode = true">
                            <i class="iconfont">&#xe618;</i>
                            {{ $t("message.修改") }}
                        </el-button>
                    </el-link>

                    <el-link :underline="false" v-show="isEditMode">
                        <!-- <el-link :underline="false" v-show="isEditMode "> -->
                        <el-button size="medium" round @click="submitForm(ruleForm)" type="primary">
                            <i class="iconfont">&#xe769;</i>
                            {{ $t("message.保存") }}
                        </el-button>
                    </el-link>
                    <el-link :underline="false" v-show="!isInit">
                        <el-button size="medium" round @click.native="refresh">
                            <i class="iconfont">&#xe667;</i>
                            {{ $t("message.刷新") }}
                        </el-button>
                    </el-link>
                </div>
            </div>
        </div>



        <div class="grid-content subtitle">
            <span>基本信息编辑</span>
        </div>
        <div class="grid-content content-margin">
            <table class="simpleRow">
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.店员编号") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.staffid" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width: 500px"></el-input>
                    </td>

                </tr>
                <tr>
                    <td style="min-width:120px">
                        <span class="simpleLabel">*员工编号</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.workno" :disabled="!isEditMode" size="mini" placeholder=""
                            style="width: 500px" @change="myFunction1()"></el-input>
                    </td>
                    <td>
                        <span v-if="showtip1" style="color:red">错误：该员工编号已经被{{ changeForm.name }}占用
                            <span @click="pushnew" style="color:blue">(查看)
                            </span>
                        </span>
                    </td>
                </tr>


                <tr>
                    <td>
                        <span class="simpleLabel">*姓名 </span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.name" :disabled="!isEditMode" size="mini" placeholder=""
                            style="width: 500px" @change="myFunction3()"></el-input>
                    </td>
                </tr>

                <tr>
                    <td>
                        <span class="simpleLabel"> *手机 </span>
                    </td>
                    <td>
                        <!-- <el-input v-model="ruleForm.mobile" :disabled="!isEditMode" style="width: 500px"></el-input> -->
                        <el-input v-model="ruleForm.mobile" :disabled="!isEditMode" size="mini" placeholder=""
                            style="width: 500px" @change="myFunction2()" type="number"></el-input>
                    </td>
                    <td>
                        <span v-if="showtip2" style="color:red">错误：该员手机已经被{{ changeForm.name }}占用 <span @click="pushnew"
                                style="color:blue">(查看)
                            </span></span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.门店") }}</span>
                    </td>
                    <td>
                        <!-- 自定义input模板 -->
                        <el-autocomplete popper-class="my-autocomplete" v-model="ruleForm.shopname"
                            :fetch-suggestions="getshoplist" :disabled="!isEditMode" placeholder="请输入门店"
                            @select="handleSelect">
                            <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick">
                            </i>
                            <template slot-scope="{item}">
                                <div class="name">{{ item.name }}</div>
                                <!-- <span class="addr">{{ item.shopid }}</span> -->
                            </template>
                        </el-autocomplete>
                    </td>
                </tr>

                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.职位") }}</span>
                    </td>
                    <td>
                        <el-select v-model="ruleForm.position" placeholder="请选择你的职位" :disabled="!isEditMode">
                            <el-option label="店员" value="employee"></el-option>
                            <el-option label="店长" value="employer"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.禁用状态") }}</span>
                    </td>
                    <td>
                        <el-switch v-model="ruleForm.state" :active-value="1" :inactive-value="0" active-text="开启"
                            inactive-text="关闭" :disabled="!isEditMode">
                        </el-switch>
                        <span style="margin-left:30px">禁用时间: {{ getformatdata }}</span>

                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.openID") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.unionID") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.最后登录") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.激活日期") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.创建者") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.更新者") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
                    </td>
                    <td>
                        <el-input v-model="ruleForm.miss" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import commonUtil from "@/utils/commonUtil";
export default {
    name: "editemployeeDetail",
    data() {


        return {
            csvTitle:'',
            csvVisible:false,  //导入dialog初始值
            shoplist:[],  // 存放门店列表数据
            hashidtoname: {}, //根据currentshopid查找门店名
            value:'',//el-switch中绑定的值
            satffid:'', //传入的query中id
            showtip1:false, //员工编号提示开关
            showtip2:false, //手机错误提示开关
            isEditMode: true,
            isInit:true,
            pass:true,   //进行input表单验证，true为可以发送新增员工接口
            content1:'',
            select1:'',
            tableHeight: 500,
            showUploadOrder: false,
            fileList: [],
            uploadData: { appid: 188, fieldgroupid: 0 },
            fieldGroupOption: [],
            //拿到根据不同的id，返回的数据
            employee: {
                appid: 188,
                id: null,
acceptthirdpartysystem: null,
appID: 188,
createdate: "2022-07-28T09:37:25.000+00:00",
createid: 100004,
currentshopid: 8,
editdate: "2022-07-28T09:37:25.000+00:00",
editid: 100004,
guidetype: null,
img: null,
info: null,
mobile: "12334",
name: "f",
position: "yes",
staffid: 5,
workno: "1",
workstatus: '',
wstate: null

            },
            //   发送的数据
            sendData: {
                appID: 188,
                filterConfig: {},
                pageConfig: {
                    page: 1,
                    pagesize: 20,
                    pageStartIndex: 0,
                },
                sortConfig: {
                    order: "",
                    prop: "",
                },
            },
            //@change发送返回接口数据 改变后的表单数据
            changeForm:{
                name:'',
                mobile:'',
                staffid:''
            },
            // 表单数据
            ruleForm: {
                value: '',//el-switch中绑定的值
                miss:'',
                shopname:'',
                currentshopid: '',//当前门店id
                appID: 188,   //appID
                id:null,
                staffid:'',  //员工id
                workno: '',  //员工编号
                name: '',    //员工姓名
                mobile: '',   //员工手机
                position: '',   //员工职位
                workstatus: '',    //员工在职状态
                state:'',//员工状态
                createdate: "2022-08-02T08:46:19.891Z",
                createid: 0,
                editdate: "2022-08-02T08:46:19.891Z",
                guidetype: 0,
                img: '',
                info: '',
                // staffid: this.$route.query.id,
            },
            // 表单验证、校验规则
           rules: {
               workno: [ //员工编号验证
                    { required: true, message: '请输入员工编号', trigger: 'blur' },
                    // { min: 3, max: 10, message: '长度在 3 到 10个字符', trigger: 'blur' },
                    // { pattern: /^[^\u4e00-\u9fa5]+$/,message:'不允许输入中文',  trigger: 'blur'},
                    { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,message:'不允许输入空格等特殊字符',  trigger: 'blur'},
                    { pattern: /[0-9a-zA-Z]{1,6}/, message: '只可以输入数字和字母', trigger: 'blur' },
                    // { pattern: /^[1-9]*$/,message:'请输入正整数',trigger: 'blur'}
                ],
                name: [
                    { required: true, message: '请输入员工姓名', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊字符', trigger: 'blur' },

                ],
               mobile: [ // 手机号验证
                    { required: true, trigger: 'change', message: '手机号不能为空' },
                    { min: 11, max: 11, trigger: 'change', message: '请输入11位手机号码' },
                   { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊字符', trigger: 'blur' },

                ],
                position: [
                    { required: true, trigger: 'blur' }
                ],
               workstatus: [
                    { required: true, trigger: 'blur' }
                ],

            },
            //关联门店
            restaurants: [],
            state: '',


            editFilter: {},

            //服务器返回订单列表
            orderList: [],

            deleteRow: null,
            deleteDialogVisible: false,
            showDateilDrawer: false,

            editUserID: String,
            editOrderID: String,

            url: "",
            name: "",

            dateTypeOptions: [
                { label: "不启用", type: 0 },
                { label: "等于", type: 1 },
                { label: "大于", type: 3 },
                { label: "小于", type: 4 },
                { label: "区间", type: 7 },
                { label: "当前时间点", type: 14 },
            ],
        };
    },
    watch: {},
    methods: {
        myFunction1() {
            // 员工编号正则判断
            if (this.ruleForm.workno == '' || this.ruleForm.workno.length >= 10 ) {
                this.$message({
                    message: "请填写正确的员工编号！！",
                    duration: 1000
                });
                this.pass = false;
            } else {
                this.pass = true;
            console.log('员工编号校验成功')
            rejecthttp(
                false,
                "get",
                "/manage/staff/getstaffbyworkno",
                {
                    appid: 188,
                    // staffid: staffid,
                    // staffid: "188",
                    workno:this.ruleForm.workno
                },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                            // 被暂用的情况
                        this.showtip1 = true; //显示提示消息
                        console.log(doc);
                        this.changeForm.name = doc.data.data.name;
                        this.changeForm.staffid = doc.data.data.staffId;
                    } else {
                        this.showtip1 = false; //关闭提示消息
                        console.log(doc);
                        console.log('员工编号被没有暂用')
                    }
                }
            );
            }
        },
        myFunction3() {
            // 姓名正则判断
            if (this.ruleForm.name == '' || this.ruleForm.name.length >= 10) {
                this.$message({
                    message: "请填写正确的姓名！！",
                    duration: 1000
                });
                this.pass = false;
            } else {
                this.pass = true;
            }
            },
        myFunction2(){
            // 手机号正则判断
            const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (this.ruleForm.mobile == '' || this.ruleForm.mobile.length <= 10 || !reg.test(this.ruleForm.mobile)) {
                this.$message({
                    message: "请填写正确的手机号！！",
                    duration: 1000
                });
                this.pass=false;
                return;
            }else{
                this.pass=true;
                console.log('手机校验成功')
                // var mobile = String(this.ruleForm.mobile)
                rejecthttp(
                    false,
                    "get",
                    "/manage/staff/getstaffbymoblie",
                    {
                        appid: 188,
                        moblie: this.ruleForm.mobile + ''
                    },
                    this,
                    (doc) => {
                        if (doc.data.Code != "MSGKEY_OK") {
                            //被占用的情况
                            this.showtip2 = true;  //显示提示消息
                            console.log(doc.data.data);
                            this.changeForm.staffid = doc.data.data.staffId;
                            this.changeForm.name = doc.data.data.name;
                        } else {
                            this.showtip2 = false;  //关闭提示消息
                            console.log('手机号被没有暂用')
                        }
                    }
                );
            }
        },
        pushnew(){
            console.log(window.location.href)
            // let id = this.$route.query.id
            let id = this.changeForm.staffid
            window.location.href = window.location.origin + window.location.pathname+`?id=${id}&appid=188&isEditMode=true`
//             this.$router.push({ name: "editemployeeDetail", query: { id: this.ruleForm.staffid, appid: "189" }, ()=> {}, () => { }
// });
        },
        //关联门店
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // var results =  restaurants;

            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.shopMain.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            console.log(item);
            this.ruleForm.shopname = item.name;
            this.ruleForm.currentshopid = item.shopid;
        },
        handleIconClick(ev) {
            console.log(ev);
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        // 表单
        onSubmit() {
            console.log('submit!');
        },

        // 保存按钮，提交表单
        submitForm(ruleForm){
            this.isEditMode = false;
            if(this.pass){

            if (this.isInit) {
                this.ruleForm.workstatus = this.value
                this.ruleForm.status = this.value
                let sendd = { ...this.ruleForm, workNo: this.ruleForm.workno, workStatus: this.ruleForm.workstatus }
                delete sendd.workno
                delete sendd.workstatus
                console.log('发送新增员工接口，查看发送的数据包')
                console.log(this.data)
                console.log(sendd)
                if (this.ruleForm.name==''){
                    console.log('姓名为空')
                }
                rejecthttp(false, 'post', "/manage/staff/addstaffinfo", sendd, this, (doc) => {
                    changeflagCLOSED(doc, 1, this)
                    if (doc.data.Code == "MSGKEY_OK") {
                        console.log(doc.data);
                        // this.refresh()
                    }
                });
            } else {
                //  //编辑员工接口
                rejecthttp(true, 'post', "/manage/staff/updatestaffinfo", this.ruleForm, this, (doc) => {
                    changeflagCLOSED(doc, 0, this)
                    if (doc.data.Code == "MSGKEY_OK") {
                        console.log(doc.data);
                    }
                });
            }
            }else{
                this.$message({
                    message: "表单验证没有通过！！",
                    duration: 1000
                });
            }
        },
        // 取消按钮
        resetForm(ruleForm){

            this.$router.push({ name: "employeeList", query: { appid: "188" } });


        },
        // 返回按钮
        backTarget() {
            this.$router.push({ name: "employeeList", query: { appid: "188" } });
        },
        //刷新按钮
        refresh() {
            //获取员工详情
            this.getstaffinfo();
        },
            //获取员工详情方法
        getstaffinfo() {
            // console.log(11111111111111111111111111111111111, this.employee)
            rejecthttp(
                false,
                "get",
                "/manage/staff/getstaffinfo",
                {
                    appid: 188,
                    staffid: this.employee.id,
                },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                        this.employee = doc.data.data;
                        this.ruleForm.workno = doc.data.data.workno;
                        this.ruleForm.name = doc.data.data.name;
                        this.ruleForm.mobile = doc.data.data.mobile;
                        this.ruleForm.position = doc.data.data.position;
                        this.ruleForm.workstatus = doc.data.data.workstatus;
                        console.log(doc.data.data)
                        this.value = doc.data.data.workstatus;
                        this.ruleForm.value = doc.data.data.workstatus;
                        this.ruleForm.delivery = doc.data.data.acceptthirdpartysystem;
                        this.ruleForm.currentshopid = doc.data.data.currentshopid;
                        this.ruleForm.shopname = this.hashidtoname[doc.data.data.currentshopid];
                        console.log(this.hashidtoname[doc.data.data.currentshopid])

                        //哈希
                        // doc.data.data.forEach(item=>{
                        //     this.hashidtoname[item.workno] = item.staffid

                        // })
                    }
                }
            );

        },

        //查找所有门店列表方法
        getshoplist(qs,cb){
            rejecthttp(false, 'get', "/manage/shop/getshoplist",{appid:188},this,(doc)=>{
                if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                    this.shoplist = doc.data.data
                    let c = []
                    this.shoplist.forEach(item => {
                        c.push({ shopid: item.shopMain.shopid, name: item.shopMain.name })
                    })
                    console.log(this.shoplist)
                    console.log(c)
                    console.log(typeof cb)
                    let h=new Promise((resolve) => {
                        resolve()
                        // cb(c)/

                    })
                    h.then(i=>{
                        if(cb){
                            cb(c)
                        }else{
                            this.refresh();

                        }
                    })

                        doc.data.data.forEach(item=>{
                            this.hashidtoname[item.shopMain.shopid] = item.shopMain.name
                        })
                    }
            })



        },



        resetEditFilter() {
            this.editFilter = {
                endDate: {
                    dateType: 0,
                    fromDate: "",
                    nowDay: 1,
                    nowType: 0,
                    toDate: "",
                },
                orderID: "",
                userID: "",
                openID: "",
                unionID: "",
                state: -1,
                address: "",
                mobile: "",
                consignee: "",
                orderDetailID: "",
                serialNo: "",
                quantity: 0,
                commodityName: "",
            };

            this.onSearch();
        },

        onSearch() {
            this.pageConfig.total = null;
            this.sendData.filterConfig = JSON.parse(JSON.stringify(this.editFilter));
            this.refresh();
        },

        editOrder(row) {
            this.showDateilDrawer = true;
            this.editUserID = row.order.userID;
            this.editOrderID = row.order.orderID;
        },

        rowStyle({ row, column, rowIndex, columnIndex }) {
            //设置表格每行间隔颜色
            if (columnIndex < 12) {
                return { background: "#FAFAFA", border: "none", color: "#111" };
            }
            if (row.order) {
                return { background: "#DDDDDD", border: "none", color: "#111" };
            }
            if (row.orderDetailID) {
                return { background: "#F0F5FC", color: "#111" };
            }
        },
        createTarget() {
            this.$router.push({ name: "editemployeeDetail", query: { appid: "188" } });
        },
        openUpload() {
            this.showUploadOrder = true;

            //获取字段转换分组列表
            rejecthttp(
                true,
                "get",
                "/manage/fieldtrans/getgrouplist",
                {
                    appid: this.uploadData.appid,
                },
                this,
                (doc) => {
                    changeflagCLOSED(doc, 0, this);
                    if (doc.data.Code == "MSGKEY_OK") {
                        this.fieldGroupOption = doc.data.data;
                        this.$set(this.fieldGroupOption, this.fieldGroupOption.length, {
                            name: "无",
                            groupid: 0,
                            appid: 188,
                        });

                        if (this.fieldGroupOption.length > 0) {
                            this.uploadData.fieldgroupid = this.fieldGroupOption[0].groupid;
                        }

                        console.log(this.fieldGroupOption);
                    } else {
                        this.$message({
                            type: "error",
                            message: doc.data.Message,
                        });
                    }
                }
            );
        },

        handleClose(done) { },

        submitUpload() {
            if (this.uploadData.fieldgroupid == 0) {
                this.$message({
                    type: "error",
                    message: "请选择字段转换分组",
                });
                return;
            }

            this.$refs.upload.submit();
        },

        handleRemove(file, fileList) {
            console.log(file, fileList);
        },

        handlePreview(file) {
            console.log(file);
        },
        paginationChange(pagesize, page, name) {
            this.sendData.pageConfig.page =
                page != -1 ? page : this.sendData.pageConfig.page;
            this.sendData.pageConfig.pagesize =
                pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
            this.refresh();
        },

        handleSuccess(res, file) {
            console.log(res);
            this.showUploadOrder = false;

            if (res.Code == "MSGKEY_OK") {
                this.refresh();
                this.$message({
                    type: "success",
                    message: res.Message,
                });
            } else {
                this.$message({
                    type: "error",
                    message: res.Message,
                });
            }

            this.fileList = [];
        },
    },

    mounted: function () {
    },
    created() {
        // this.getstaffinfo();
        console.log(this.$route.query.id)
        this.ruleForm.staffid = this.$route.query.id;
        this.employee.id = this.$route.query.id;
        this.getshoplist()
        // console.log(this.$route.query.appid)

        //判断传入参
        if (this.$route.query.id) {
            this.employee.id = this.$route.query.id;  // 将前两按钮的本行中的id,接收并传入到article.id中
            this.isEditMode = this.$route.query.isEditMode ? true : false;
            this.isInit = false;

        }

    },
    computed: {
        sessionHeaders() {
            return { dmfsession: this.$store.state.DMFSession };
        },
        getformatdata() {
            const dt = new Date()
            return commonUtil.formatDate(dt);
        },
    },

    components: {
        pagination,
    },
};
</script>

<style scoped >









.el-table /deep/ td {
    user-select: text !important;
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
/* 自定义Input模板 */
    .grid-content .content-margin.my-autocomplete .li {
             line-height: normal;
             padding: 7px;
        }
                   .grid-content .content-margin.my-autocomplete .li .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
                   .grid-content .content-margin.my-autocomplete .li .addr {
            font-size: 10px;
            color: #9f9c9c;
        }

                   .grid-content .content-margin .my-autocomplete .li .highlighted .addr {
            color: #ddd;
        }

</style>



// WEBPACK FOOTER //
// src/pages/employee/editemployeeDetail.vue